module.exports = __webpack_public_path__ + "img/CS-UltraLine-HD-User.38ab6d98.jpg";